export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-10">
          联系我们 / 投稿咨询
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 text-center border border-background-200">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-5">
              <i className="ri-mail-send-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 font-heading mb-3">
              有网红爆料线索？欢迎投稿
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              如果您掌握真实的网红黑料、内幕信息或实锤证据，
              欢迎通过以下方式联系我们。所有投稿信息严格保密，
              爆料人身份绝不公开，优质线索一经采用将给予丰厚奖励。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="mailto:tips@wanghongbaoliao.com"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-base"></i>
                </div>
                发送邮件投稿
              </a>
              <div className="flex items-center gap-3 text-sm text-foreground-500">
                <span>或通过社交媒体私信</span>
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 cursor-pointer hover:bg-background-300 transition-colors">
                    <i className="ri-wechat-line text-foreground-600"></i>
                  </span>
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 cursor-pointer hover:bg-background-300 transition-colors">
                    <i className="ri-weibo-line text-foreground-600"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}